<script>
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import BreadcrumbsWrapper from '@components/breadcrumbs/breadcrumbs-wrapper.vue';
import EditableText from '@components/editables/editable-text.vue';
import { exerciseMethods, authComputed } from '@state/helpers';

export default {
  components: {
    BreadcrumbsWrapper,
    EditableText,
  },
  props: {
    exercise: {
      type: Object,
      required: true,
      default: () => {},
    },
    currentExercise: {
      type: Object,
      required: true,
      default: () => {},
    },
    initExercise: {
      type: Object,
      required: true,
      default: () => {},
    },
    isEditable: {
      type: Boolean,
      required: false,
    },
    inPanel: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      exerciseHeroClone: null,
    };
  },
  computed: {
    ...authComputed,
  },
  beforeMount() {
    this.exerciseHeroClone = cloneDeep(this.exercise);
  },
  mounted() {},
  methods: {
    ...exerciseMethods,
    handleUpdateExerciseProps(exercise) {
      this.$emit('update-exercise-props', exercise);
    },
    updateExerciseTitle(value) {
      this.exerciseHeroClone.label = value;
      this.setUpdateExerciseTitle(value);
    },
  },
  watch: {
    currentExercise: {
      deep: true,
      handler(newVal, oldVal) {
        if (isEqual(this.currentExercise, this.initExercise)) {
          this.exerciseHeroClone = cloneDeep(this.initExercise);
        }
      },
    },
  },
};
</script>

<template>
  <div class="hero">
    <BreadcrumbsWrapper v-if="!inPanel" prevPageName="Exercises" />

    <div class="hero-section">
      <h6 class="section-title">Exercise Name</h6>
      <h1 class="hero-title">
        <EditableText
          v-if="isEditable || inPanel"
          placeholderTxt="New Exercise Title"
          :mode="`${inPanel ? 'edit' : ''}`"
          :text="exerciseHeroClone.label"
          :canEdit="isEditable || inPanel"
          @update-editable-value="updateExerciseTitle"
        />
        <span v-else>{{ exerciseHeroClone.label }}</span>
      </h1>

      <h6 class="section-title">Description</h6>
      <div class="row">
        <div class="col-6">
          <BaseInputTextarea
            v-if="isEditable || inPanel"
            v-model="exerciseHeroClone.description"
            name="description"
            :rows="`${inPanel ? 3 : 5}`"
            :light="true"
            @change="handleUpdateExerciseProps(exerciseHeroClone)"
          />
          <p v-else>
            {{ exercise.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.hero {
  justify-content: space-between;
  padding: 3.2rem 6rem 3.7rem;

  .hero-section {
    flex: 1;
  }

  .description-wrapper {
    background: white;
    border-radius: $base-border-radius;
    height: 9.5rem;
    overflow-y: scroll;
    padding: 1rem;
  }
}
</style>
